// extracted by mini-css-extract-plugin
export var closeButton = "_dq-1";
export var closeX = "_dq-3";
export var container = "_dq-0";
export var image = "_dq-2";